class GreenShineProductVideo extends HTMLElement {
  connectedCallback() {
    if (this.dataset.videoReady === 'true') return;
    this.dataset.videoReady = 'true';
    this.frame = this.querySelector('[data-gs-product-video-frame]');
    this.playButton = this.querySelector('[data-gs-product-video-play]');
    if (!this.frame || !this.playButton) return;
    this.onPlay = () => this.loadVideo();
    this.playButton.addEventListener('click', this.onPlay, { once: true });
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.onPlay);
  }

  loadVideo() {
    const source = this.playButton?.dataset.videoSrc;
    if (!source || this.dataset.videoLoaded === 'true') return;
    this.dataset.videoLoaded = 'true';

    const iframe = document.createElement('iframe');
    iframe.src = source;
    iframe.title = `${this.dataset.videoModel || 'GreenShine'} video`;
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    this.frame.replaceChildren(iframe);

    try {
      const result = window.Shopify?.analytics?.publish?.('greenshine_video_play', {
        video_family: this.dataset.videoFamily || '',
        video_id: this.dataset.videoId || '',
        video_locale: this.dataset.videoLocale || document.documentElement.lang || '',
        video_model: this.dataset.videoModel || '',
        page_location: window.location.href.split('#')[0]
      });
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (error) {
      // Playback must not depend on analytics availability.
    }
  }
}

if (!customElements.get('greenshine-product-video')) {
  customElements.define('greenshine-product-video', GreenShineProductVideo);
}
